import React from "react";
import { useQuery } from "@apollo/client";
import { Navigate, useLocation } from "react-router-dom";
import Auth from "../utils/auth";
import { GET_ME } from "../pages/user/gql/queries";

const Pledger = ({ children }) => {
    const location = useLocation();
    const { data, loading, error } = useQuery(GET_ME);

    if (error?.graphQLErrors?.some(e => e.extensions?.code === 'UNAUTHENTICATED')) {
        Auth.logout();
        return null;
    }

    if (loading) {
        return null;
    }

    const me = data?.me;
    const isPledged = me?.isPledged;

    if (isPledged === false && location.pathname !== "/takhmeen") {
        return <Navigate to="/takhmeen" replace state={{ referrer: location.pathname }} />;
    }

    return children;
};

export default Pledger;

